<template>
  <div class="apply-add-form">
    <template v-if="fromShow">
      <my-form
        ref="formRef"
        :data.sync="data"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />
      <!-- submit and reset -->
      <b-row>
        <b-col
          cols="12"
          class="my-form_btns"
        >
          <!-- <p class="text-secondary">
            {{ explain }}
          </p> -->
          <b-button
            variant="primary"
            class="mr-3"
            :disabled="loading"
            @click="send"
          >
            {{ $t('_components.btns.send') }}
          </b-button>
          <!-- <b-button
            variant="outline-primary"
            :disabled="loading"
            @click="saveDrafts"
          >
            {{ $t('_components.btns.saveDrafts') }}
          </b-button> -->
        </b-col>
      </b-row>
    </template>
    <component
      :is="flowKey"
      v-else
      :process-key="processKey"
      :explain="explain"
      @cancel="handleCustFormCancel"
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue';
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import website from '@/config/website';
import { turnSite, turnSiteFlow } from '@/api/worker/turnSite'
import { templateFormat, templateSubmitFormat } from '@/util/func'
import { mapGetters } from 'vuex'
import { deepClone } from '@/util/util'
// custForm
// import Induction from './custForm/induction.vue'
import Induction from '@/views/apply/components/custForm/induction.vue'
import WORKER from '@/api/worker/index';
import { getDetail } from '@/api/system/post';
import { processOption } from '@/config/processOption'
import { transferDormitory } from '@/api/worker/transferDormitory'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    Induction,
  },
  props: {
    formId: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    explain: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      fromShow: true,
      flowKey: '',
      form: {
        isPass: false,
      },
      isDrafts: false,
      loading: false,
      data: {
        // deptId: null,
        // projectId: 6,
      },
      columns: [],
      hasDept: false,
      staffQueryParams: {
        8: {
          status: 1,
        },
        7: {
          status: 1,
        },
        1: {
          status: 1,
        },
      },
      baseData: [],
      allTempList: [],
    }
  },
  watch: {
    'data.newDormitoryId': {
      handler() {
        // this.data.returnDate = ''
        this.data.newUnitId = ''
        // this.refreshTmplate()
      },
    },
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    workerId() {
      return this.userAllInfo.workerId
    },
    staffId() {
      return this.userAllInfo.staffId
    },
    option() {
      const columns = []
      this.columns.forEach(item => {
        const dictQuery = {}
        const temp = item
        if (item.field === 'lastWorkingDay') {
          const currentDate = moment().add(7, 'd').format('YYYY-MM-DD')
          temp.formOption.minDate = currentDate
        }
        if (item.field === 'teamId') {
          dictQuery.id = this.data.projectId
        }

        if (item.field === 'newBlkId') {
          dictQuery.dormitoryId = this.data.newDormitoryId
          temp.formOption.hide = !this.data.newDormitoryId
          temp.formOption.disabled = !this.data.newDormitoryId
        }

        if (item.field === 'newUnitId') {
          dictQuery.blkId = this.data.newBlkId
          temp.formOption.disabled = !this.data.newBlkId
          temp.formOption.hide = !this.data.newBlkId
        }

        if (item.field === 'workerId') {
          if (this.data.type === '2') {
            temp.formOption.hide = true
          }
        }

        temp.formOption.dictQuery = dictQuery
        if (temp.field !== 'workerNames') {
          columns.push(temp)
        }
        // columns.push(temp)
      })
      const option = {
        columns,
      }
      return option
    },
  },
  onLoad() {
    // this.getDetailData()
  },
  mounted() {
    // this.getDetailData()
    if (this.formId) {
      this.getDetailData()
    }
  },
  methods: {
    // async onload(id, loading = true) {
    //   this.loading = loading
    //   const res = await WORKER.getWorkBaseDetail({ workerID: id })
    //   this.data = res.data.data
    //   this.loading = false
    // },
    async getDetailData() {
      const { data } = await WORKER.getWorkBaseDetail({ workerID: this.workerId })
      const baseData = data.data
      this.baseData = baseData
      this.data.projectId = String(baseData.infoVO.projectId)
      this.data.applicationDate = moment().format('YYYY-MM-DD')
      this.onLoad(this.formId)
    },
    // 刷新流程模板
    refreshTmplate() {
      this.columns = templateFormat(this.allTempList)
    },
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit');
    },
    resetForm() {
      this.form = {}
    },
    onLoad(formId) {
      templateFormAPI.detail({ formId }).then(res => {
        const temp = res.data.data.records
        const setDictQuery = item => {
          const dictQuery = {}
          // if (item.dictCode === 'trade') {
          //   dictQuery.specialistId = this.data.specialistId
          // }
          return dictQuery
        }
        // const setDictQuery = item => {
        //   let dictQuery = {}
        //   if (item.dictCode === 'post') {
        //     dictQuery.deptId = this.data.deptId
        //   }
        //   return dictQuery
        // }
        this.allTempList = deepClone(temp)
        const templateFieldsList = templateFormat(temp, setDictQuery)// , setDictQuery)
        templateFieldsList.sort((a, b) => {
          if (a.sort < b.sort) {
            return false
          }
          return true
        })
        // this.columns = templateFieldsList.reverse()
        this.columns = templateFieldsList
      })
    },
    send() {
      this.isDrafts = false
      this.$refs.formRef.validationForm()
    },
    saveDrafts() {
      this.isDrafts = true
      this.$refs.formRef.validationForm()
    },
    handleSubmit(form) {
      // const params = form
      const params = templateSubmitFormat(form, this.columns)
      // 针对除files以外的拼接字符串方法
      Object.entries(params).forEach(item => {
        if (item[0] !== 'files') {
          params[item[0]] = Array.isArray(item[1]) ? item[1].join(',') : item[1]
        }
      })
      params.processKey = this.processKey
      params.formId = this.formId
      const router = website.staffProcessRouter

      if (this.isDrafts) {
        // const option = processOption[this.processId]
        const option = processOption[this.formId]
        applyAPI.workerSaveAndStart(params, router[params.formId]).then(res => {
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      } else {
        // const option = processOption[this.processId]
        const option = processOption[this.formId]

        // const option = processOption[this.processId]
        transferDormitory(params, { option: JSON.stringify(option) }).then(res => {
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          // this.$emit('submit', this.form)
        })
      }
    },
    handleCustFormCancel() {
      this.flowKey = ''
      this.fromShow = true
      this.onLoad(this.formId)
    },
  },
}

</script>

<style lang='scss' scoped>
.apply-add-form{
    height: 100%;
    position: relative;
    .my-form{
      height: calc(100% - 100px);
      position: relative;
      overflow: hidden;
      &_btns{
        left: 0;
        right: 0;
        position: absolute;
        bottom: 0;
        text-align: center;
        border-top: 1px solid #EBE9F1;
        background: #FFF;
        padding: 1.5rem 0;
      }
    }
}
</style>
